import React, { useEffect, useContext, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import { AppSettings } from "./../../config/app-settings.js";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { auth } from "../../api";
import "react-phone-number-input/style.css";
import "@sweetalert2/theme-dark/dark.css";
import PhoneInput from "react-phone-number-input";
import Swal from "sweetalert2";
import { isValidEmail } from "../../utils/helper.jsx";
function PublicRegister() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const context = useContext(AppSettings);
  const [inputs, setInputs] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    numberOfTechnician: "1",
    company: "",
  });
  const [termModal, setTermModal] = useState(false);

  const [phone, setPhone] = useState("");
  const downloadIcon =
    "data:image/svg+xml;base64,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";
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = React.useState(false);
  const [confirm, setConfirm] = React.useState(false);
  const [modalError, setModalError] = React.useState(false);

  //forgot

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);
  const tooltip = (word) => (
    <Tooltip id="tooltip">
      <strong>{word}</strong>
    </Tooltip>
  );
  const [agree, setAgree] = useState(false);

  const onAgree = () => {
    setTermModal(false);
    setAgree(true);
  };

  const onGoLogin = () => {
    window.location.href = "https://app.groundup.ai";
  };

  async function handleSubmit(event) {
    event.preventDefault();
    if (!isValidEmail(inputs.email)) {
      Swal.fire({
        icon: "error",
        title: "Warning",
        text: "Invalid email format",
      });
      return;
    }
    if (!agree) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please agree to the terms and conditions",
      });
      return;
    }
    if (password !== inputs.password) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Password does not match",
      });

      return;
    }
    //check if firstname or lastname is not empty or space
    if (inputs.firstname.trim() === "" || inputs.lastname.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Invalid Name",
      });

      return;
    }

    // check if phone number is less than 5 characters
    if (phone.length < 8) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Invalid phone number",
      });
      return;
    }
    setConfirm(true);
  }
  async function onSubmit() {
    try {
      //check if email format is correct

      setOpen(false);
      setConfirm(false);
      setLoading(true);
      const tmp = { ...inputs, phone };
      const response = await auth.publicRegister(tmp);
      setLoading(false);
      if (response.ok) {
        const body = await response.json();

        if (body.success) {
          //toast.success(body.message);
          toast.success("Please check your email", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setOpen(false);
          setSubmitted(true);
        } else {
          toast.error("Email not found");
        }
      } else {
        setModalError(true);
        const body = await response.json();
        setOpen(false);
        let message = body.message;

        toast.error(message, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (e) {
      console.log(e)
      setOpen(false);
      toast.error(e);
      setModalError(true);
      setLoading(false);
    }
  }
  return (
    <div className="login" style={{ background: "#061929" }}>
      <LoadingIndicator open={loading} />
      <div style={{ width: "100%", padding: "0 50px" }}>
        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div className="my-1 text-center">
              <h2>Start your 14-day free trial today!</h2>
            </div>
            <div className="row">
              <div className="col-md-6 col-12" style={{ padding: "30px" }}>
                <div className="card" style={{ marginTop: "45px" }}>
                  <div
                    className="card-body"
                    style={{ border: "1px solid #45535f" }}
                  >
                    <h5 className="card-title">Why Choose Our CMMS?</h5>
                    <ul
                      className="list-group list-group-flush"
                      style={{ paddingLeft: "20px" }}
                    >
                      <li
                        className="list-group-item"
                        style={{ textIndent: "-20px" }}
                      >
                        <span className="fw-bold">
                          📋 Streamlined Work Orders:
                        </span>{" "}
                        Manage tasks efficiently with an intuitive interface.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textIndent: "-20px" }}
                      >
                        <span className="fw-bold">🌐 Web & Mobile Access:</span>{" "}
                        Stay connected anywhere, anytime, on any device.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textIndent: "-20px" }}
                      >
                        <span className="fw-bold">🛠️ Empower Technicians:</span>{" "}
                        Simplify task tracking and updates for workers on the
                        go.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textIndent: "-20px" }}
                      >
                        <span className="fw-bold">🔍 Real-Time Insights:</span>{" "}
                        Monitor progress and performance with instant reports.
                      </li>
                      <li
                        className="list-group-item"
                        style={{ textIndent: "-20px" }}
                      >
                        <span className="fw-bold">
                          🔄 Seamless Integration:
                        </span>{" "}
                        Easily integrate with existing systems and workflows.
                      </li>
                    </ul>
                    <p
                      className="mt-3 text-center"
                      style={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      <strong>
                        Your ultimate tool for efficient maintenance management!
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12" style={{ padding: "30px" }}>
                <div>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip(
                      "This will be the login email used for your CMMS Dashboard"
                    )}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Email <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <input
                    type="text"
                    name="email"
                    value={inputs.email}
                    onChange={handleChange}
                    required={true}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                    placeholder="Enter Your Business Email"
                  />
                </div>
                <div>
                  <div className="row">
                    <div
                      className="col-md-6 col-12"
                      style={{ marginTop: "15px" }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={tooltip(
                          "This will be the password to login into your CMMS Dashboard."
                        )}
                      >
                        <label
                          className="form-label"
                          style={{ minHeight: "15px" }}
                        >
                          Password <span className="text-danger">*</span>
                        </label>
                      </OverlayTrigger>
                      <input
                        type="password"
                        name="password"
                        value={inputs.password}
                        onChange={handleChange}
                        required={true}
                        className="form-control form-control-lg bg-white bg-opacity-5"
                        placeholder="Create Password"
                      />
                    </div>

                    <div
                      className="col-md-6 col-12"
                      style={{ marginTop: "15px" }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={tooltip(
                          "Re-confirm your password to login into your CMMS Dashboard."
                        )}
                      >
                        <label
                          className="form-label"
                          style={{ minHeight: "15px" }}
                        >
                          Confirm Password{" "}
                          <span className="text-danger">*</span>
                        </label>
                      </OverlayTrigger>
                      <input
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required={true}
                        className="form-control form-control-lg bg-white bg-opacity-5"
                        placeholder="Confirm Password"
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="row">
                    <div
                      className="col-md-6 col-12"
                      style={{ marginTop: "15px" }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={tooltip("Your First Name")}
                      >
                        <label
                          className="form-label"
                          style={{ minHeight: "15px" }}
                        >
                          First Name <span className="text-danger">*</span>
                        </label>
                      </OverlayTrigger>
                      <input
                        type="text"
                        name="firstname"
                        value={inputs.firstname}
                        onChange={handleChange}
                        required={true}
                        className="form-control form-control-lg bg-white bg-opacity-5"
                        placeholder="Enter Your First Name"
                      />
                    </div>
                    <div
                      className="col-md-6 col-12"
                      style={{ marginTop: "15px" }}
                    >
                      <OverlayTrigger
                        placement="top"
                        overlay={tooltip("Your Last Name")}
                      >
                        <label
                          className="form-label"
                          style={{ minHeight: "15px" }}
                        >
                          Last Name <span className="text-danger">*</span>
                        </label>
                      </OverlayTrigger>
                      <input
                        type="text"
                        name="lastname"
                        value={inputs.lastname}
                        onChange={handleChange}
                        required={true}
                        className="form-control form-control-lg bg-white bg-opacity-5"
                        placeholder="Enter Your Last Name"
                      />
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "15px" }}>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip("Your Phone Number")}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Phone Number <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <PhoneInput
                    international={true}
                    defaultCountry="SG"
                    value={phone}
                    onChange={setPhone}
                  />
                </div>
                <div style={{ marginTop: "15px" }}>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip("Your Company Name/")}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Company Name <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <input
                    type="text"
                    name="company"
                    value={inputs.company}
                    onChange={handleChange}
                    required={true}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                    placeholder="Enter Your Company Name"
                  />
                </div>
                <div style={{ marginTop: "15px" }}>
                  <OverlayTrigger
                    placement="top"
                    overlay={tooltip("Company Name.")}
                  >
                    <label className="form-label" style={{ minHeight: "15px" }}>
                      Number of Technician{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </OverlayTrigger>
                  <input
                    type="number"
                    name="numberOfTechnician"
                    value={inputs.numberOfTechnician}
                    onChange={handleChange}
                    required={true}
                    min={1}
                    className="form-control form-control-lg bg-white bg-opacity-5"
                    placeholder="Enter Number of Technician"
                  />
                </div>
                <div className="form-check" style={{ marginTop: "15px" }}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={agree}
                    checked={agree}
                    onChange={(e) => setAgree(e.target.checked)}
                    id="flexCheckIndeterminate"
                  />
                  <span
                    className="form-check-label"
                    htmlFor="flexCheckIndeterminate"
                  >
                    By checking this box, you agree to our{" "}
                    <span
                      style={{
                        color: "#3dd2a5",
                        fontWeight: "bold",
                        cursor: "pointer",
                      }}
                      onClick={() => setTermModal(true)}
                    >
                      Term and Conditions
                    </span>
                  </span>
                </div>
                <div style={{ textAlign: "center" }}>
                  <button
                    type="submit"
                    disabled={loading}
                    className="iframe-button"
                  >
                    Start a Free Trial
                  </button>
                </div>
              </div>
            </div>
            <ConfirmationDlg
              title="Warning"
              open={modalError}
              onClose={() => setModalError(false)}
              btnSubmitText={"Login CMMS"}
              onSubmit={onGoLogin}
              btnCancelText={"Cancel"}
            >
              <h4>Your Email is already registered, Please Login</h4>
            </ConfirmationDlg>
            <ConfirmationDlg
              title="Confirm Submission"
              open={confirm}
              onClose={() => setConfirm(false)}
              btnSubmitText={"Yes!"}
              onSubmit={onSubmit}
              btnCancelText={"Cancel"}
            >
              <h4>Are you ready to start your CMMS dashboard?</h4>
            </ConfirmationDlg>
            <ConfirmationDlg
              size={"lg"}
              open={termModal}
              onClose={() => setTermModal(false)}
              title="Terms of Use"
              btnCancelText={"Close"}
              btnSubmitText={"Agree"}
              onSubmit={onAgree}
            >
              <div style={{ height: "calc(100vh - 450px)", overflow: "auto" }}>
                <p>
                  By signing the Form, or accessing or using the services
                  provided by Groundup.ai, you agree, on behalf of you and your
                  company (“Customer”), to be bound by and to comply with these
                  Terms of Use (together with an Order Form, the “Agreement”).
                  For good and valuable consideration, the receipt of which is
                  acknowledged by each party, the parties agree as follows:
                </p>
                <h3>Definitions</h3>
                <ul>
                  <li>
                    <strong>“Contract Start Date”:</strong> Means the
                    commencement of the Initial Term, as set forth in the Order
                    Form.
                  </li>
                  <li>
                    <strong>“Customer Content”:</strong> Any information, data,
                    images, and other content, in any form or medium, that is
                    submitted by or collected from or on behalf of Customer
                    through the Services, including data and information
                    collected from or pertaining to Users, but excluding the
                    Usage Data.
                  </li>
                  <li>
                    <strong>“Documentation”:</strong> The documentation that
                    Groundup.ai makes generally available to its customers in
                    any form related to the Services.
                  </li>
                  <li>
                    <strong>“Effective Date”:</strong> The date set forth in the
                    Order Form.
                  </li>
                  <li>
                    <strong>“Fees”:</strong> The fees set forth in an Order Form
                    for the Services and Professional Services, if applicable.
                  </li>
                  <li>
                    <strong>“Hardware”:</strong> Any hardware, such as machine
                    sensors, that may be resold by Groundup.ai to Customer from
                    the original seller or manufacturer (each, an "OEM").
                  </li>
                  <li>
                    <strong>“Initial Term”:</strong> The initial term length for
                    the Services set forth in the Order Form.
                  </li>
                  <li>
                    <strong>“Intellectual Property Rights”:</strong> All patent,
                    copyright, trademark, trade secret, rights in know-how,
                    business domain names, designs, and other proprietary and
                    intellectual property rights recognized in any jurisdiction
                    worldwide, including moral rights.
                  </li>
                  <li>
                    <strong>“Marks”:</strong> A party’s name, logo, and
                    trademarks.
                  </li>
                  <li>
                    <strong>“Order Form”:</strong> The initial order for the
                    Services, and any subsequent orders, entered into between
                    the parties in writing (including via a web interface),
                    specifying, among other things, the Services, Fees, payment
                    terms, and other relevant terms as agreed to between the
                    parties.
                  </li>
                  <li>
                    <strong>“Professional Services”:</strong> Any professional
                    or consulting services that are ancillary to the Services
                    rendered by Groundup.ai to Customer, but specifically
                    excluding any support and maintenance provided hereunder.
                  </li>
                  <li>
                    <strong>“Reports”:</strong> The tangible reports generated
                    by Customer’s use of the Services.
                  </li>
                  <li>
                    <strong>“Services”:</strong> The products and services set
                    forth in an executed Order Form that are made available by
                    Groundup.ai to Customer, including the Groundup.ai website,
                    software, API, and mobile application, but excluding the
                    Hardware.
                  </li>
                  <li>
                    <strong>“Services Term” and “Term”:</strong> Defined in
                    Section 10.1 below.
                  </li>
                  <li>
                    <strong>“Third-Party Services”:</strong> Any products or
                    services provided by third parties that may be integrated
                    with or accessed through the Services.
                  </li>
                  <li>
                    <strong>“Usage Data”:</strong> Any anonymized and aggregated
                    data that is derived from the processing of the Customer
                    Content or the access or use of the Services by or on behalf
                    of Customer, that in no way identifies or refers to Customer
                    or Users, and any statistical or other analysis,
                    information, or data based on or derived from the foregoing.
                  </li>
                  <li>
                    <strong>“User”:</strong> Customer’s employees, independent
                    contractors, or other third parties who are authorized by
                    Customer to access and use the Services under the rights
                    granted to Customer in the Agreement. The number of Users
                    authorized to access the Services is set forth on the
                    applicable Order Form, if applicable.
                  </li>
                </ul>

                <h3>The Services</h3>
                <h4>2.1. Provision of the Services</h4>
                <p>
                  During the Services Term and subject to the terms and
                  conditions of the Agreement:
                </p>
                <ul>
                  <li>
                    Customer may access and use the Services pursuant to the
                    terms of the Agreement; and
                  </li>
                  <li>
                    Groundup.ai hereby grants to Customer a limited,
                    non-exclusive, non-transferable (except as set forth in
                    Section 11), non-sublicensable license to use and copy the
                    Documentation as reasonably required to access and use the
                    Services. Groundup.ai will use commercially reasonable
                    efforts to maintain the security of the Services.
                  </li>
                </ul>

                <h4>2.2. Modifications</h4>
                <p>
                  Groundup.ai may revise or remove features, functionality, or
                  service levels of the Services at any time. If any such
                  revision or removal materially degrades Customer’s use of the
                  Services, Customer may, within thirty (30) days’ notice of the
                  revision or removal, terminate the applicable Order Form,
                  without cause. Groundup.ai will use commercially reasonable
                  efforts to notify Customer of any changes to the Services via
                  email and/or by posting such changes to Groundup.ai’s website.
                </p>

                <h4>2.3. Privacy Policy</h4>
                <p>
                  Groundup.ai’s privacy policy is incorporated herein by
                  reference in relation to any data collected from Users through
                  their use of the Services. Groundup.ai reserves the right to
                  modify its privacy policy in its reasonable discretion from
                  time to time.
                </p>

                <h4>2.4. Subcontractors</h4>
                <p>
                  Customer acknowledges and agrees that Groundup.ai may use
                  subcontractors and other third-party service providers in its
                  provision of the Services, provided that Groundup.ai remains
                  liable for such third party’s breach of the Agreement.
                </p>
                <h4>2.5. Marketing and Materials</h4>
                <p>
                  The Customer grants Groundup.ai permission to use media and
                  results generated during the trial for marketing purposes,
                  subject to revocation with reasonable notice.
                </p>
              </div>
            </ConfirmationDlg>
          </form>
        ) : (
          <div className="row justify-content-center">
            <div className="col-12 col-md-6">
              <Card className="mb-4">
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                  Congratulations Trial Account Registered Successfully
                </CardHeader>
                <CardBody>
                  <div>
                    <p style={{ fontSize: "16px" }}>
                      Thank you for registering to Groundup.ai CMMS, you now
                      have a 14-day trial account ready for you to explore! To
                      activate your account, we have sent an activation email to
                      you registered email. Activate it to start your free
                      trial!
                    </p>
                    <div className="row justify-content-between">
                      <div
                        className="col-12 col-md-12 col-xl-7 text-sm-center text-md-end text-xl-end"
                        style={{ marginTop: "30px" }}
                      >
                        <a
                          style={{ marginTop: "20px" }}
                          href="https://app.groundup.ai"
                          target={"_blank"}
                          className="iframe-button"
                        >
                          Login to CMMS Dashboard
                        </a>
                      </div>
                      <div
                        className="col-12 col-md-12 col-xl-5 text-sm-center text-md-start text-lg-start"
                        style={{ marginTop: "30px" }}
                      >
                        <a
                          style={{ marginTop: "20px" }}
                          href="https://play.google.com/store/apps/details?id=com.groundup.cmms"
                          target={"_blank"}
                        >
                          <img
                            src={downloadIcon}
                            style={{ width: "120px", marginTop: "-7px" }}
                            alt=""
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PublicRegister;
